import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { StoreContext } from "../../../../Store/Provider";
import clsx from "clsx";
import { Drawer } from "@material-ui/core";
import Sidebar from "../Sidebar/Sidebar";
import CloseIcon from "@material-ui/icons/Close";
// import SearchIcon from '../../../SVG/SearchIcon';
import SearchIcon from "@material-ui/icons/Search";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import "./searchShipments.css";
import { routeConstant } from "../../../../Route/utils/routeConstant";
import { NotificationManager } from "react-notifications";

function SearchShipment() {
  const [search, setSearch] = useState("");
  const context = useContext(StoreContext);
  const classes = useStyles();
  const history = useNavigate();

  const searchIcon = () => {
    if (search) {
      context.setShipmentNo(search);
      history(routeConstant.SearchShipmentResult);
    } else {
      NotificationManager.error("Please fill search value!", "", 2000);
    }
  };
  return (
    <div className="home">
      <Header />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={{
            paper: clsx(classes.drawerPaperleft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            }),
          }}
        >
          <Sidebar />
        </Drawer>
        <main
          className={clsx(classes.content, {
            [classes.contentwidth]: context.menuBar,
            [classes.contentFullWidth]: !context.menuBar,
          })}
        >
          <div className="searchShipmentScreen">
            <h5>Search Shipment</h5>
            <div className="headersearch searchShipmentDiv">
              <input
                value={search}
                type="text"
                className="form-control"
                id="headersearch"
                onChange={(event) => {
                  setSearch(event.target.value);
                }}
                placeholder="Search Shipment"
                onKeyPress={(event) => {
                  if (event.key === "Enter" && search) {
                    context.setShipmentNo(search);
                    history(routeConstant.SearchShipmentResult);
                  } else if (event.key === "Enter" && search) {
                    NotificationManager.error("Please enter a search term");
                  }
                }}
              />
              <SearchIcon
                onClick={search ? () => searchIcon() : () => {}}
                style={{ color: "rgba(var(--text-heading-dark))" }}
                className="searchIcon"
              />
              {search && (
                <CloseIcon
                  className="searchClearIcon"
                  onClick={() => {
                    setSearch("");
                  }}
                />
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentFullWidth: {
    width: "calc(100% - 2.5rem)",
  },
  contentwidth: {
    width: "calc(100% - 16rem)",
  },
  drawerLeft: {
    width: "16rem",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default SearchShipment;
